import { render, staticRenderFns } from "./ReportDocumentsPanel.vue?vue&type=template&id=0850f945"
import script from "./ReportDocumentsPanel.vue?vue&type=script&lang=ts"
export * from "./ReportDocumentsPanel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports